import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { VbUiProgressBarComponent } from './VbUiProgressBar.Component';

const components = [
	VbUiProgressBarComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		ButtonsAngularModule,
		CommonModule,
		FormGroupAngularModule,
		FormsModule,
		TranslateModule
	],
	providers: []
})
export class ProgressBarAngularModule {
}
